import firebase from 'firebase/app';

export const generatedOutreachAdd = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, name) =>{

    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc(docId)

    messagesRef.update({
        ContentCreated: firebase.firestore.FieldValue.arrayUnion({
            ProspectName: name,
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            CreatedAt: new Date(),
        })
    }).then(() =>{
        // saveSearch(fbProfile, auth, profile, LIurl, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}